import { WebpackTranslateLoader } from './webpack-translate.loader';

export {
  WebpackTranslateLoader
};
